import BaseModel from './BaseModel';

/** Class representing a tkt instance. */
class TktInstance extends BaseModel {
    hasModule = (module) => {
        return this.options && this.options.modules &&
           this.options.modules.includes(module);
    }

    hasEventivalIntegration = (setting) => {
        const eventival = setting?.integrations?.eventival;
        return (eventival?.api_key?.length > 0 && eventival.name?.length > 0 && eventival.year?.length > 0);
    }

    hasFionaIntegration = (setting) => {
        const fiona = setting?.integrations?.fiona;
        return (fiona?.api_key?.length > 0 && fiona.name?.length > 0 && fiona.edition_id?.length > 0);
    }

    hasCinechIntegration = (setting) => {
        const cinech = setting?.integrations?.cinech;
        return (cinech?.url?.length > 0 && cinech.cinema_ids?.length > 0);
    }

    hasJsonIntegration = (setting) => {
        return (
            !!setting?.integrations?.json?.import?.screenings?.enabled &&
            setting.integrations.json.places_key?.length > 0
        );
    }

    hasOzuIntegration = (setting) => {
        const ozu = setting?.integrations?.ozu;
        return !!ozu?.import?.screenings?.enabled;
    }
}

export default TktInstance;
